import { render } from "./statsCard.vue?vue&type=template&id=55e24d0e"
import script from "./statsCard.vue?vue&type=script&lang=js"
export * from "./statsCard.vue?vue&type=script&lang=js"
script.render = render

export default script